/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UncontrolledTooltip, CardHeader, CardBody, Button, Card } from "reactstrap";
import DataTable from "react-data-table-component";
import { Plus } from "react-feather";
import { useDebouncedCallback } from "use-debounce";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { handleErrors } from "../../../services/handleErrors";
import useFetcher from "../../../hooks/useFetcher";
import { LabSelect } from "../../course/select";
import { CustomLabel } from "../../../ui/labels";
import { InputText } from "../../../ui/inputs";
import { SpinnerButtonPrimary } from "../../../ui/buttons";
import { GridGroup } from "../styles";
import { postMedicalStudies, patchMedicalStudies, getMedicalStudies, getProveedoresMedicalStudies } from "../../../services/candidatosNPServices";
import { BlurSpinner } from "../../BlurSpinner";
import { patchFile, uploadFiles } from "../../../services/fileServices";
import { DownloadFileButton } from "../../RelevosInfoGeneral/styles";
import { handleClickFile } from "../../RelevosInfoGeneral/utils";
import { getFileIconName } from "../../../pages/FileManager/fileItem";
import { AsyncLabSelect } from "../../AsyncLabSelect";
import { formatearFecha } from "../utils";

const createOrUpdateMedicalStudies = async (medicalStudie, estudioId) => {
  if (estudioId) {
    const res = await patchMedicalStudies(medicalStudie, estudioId);
    return res;
  }
  const res = await postMedicalStudies(medicalStudie);
  return res;
};

export const uploadOrPatchFileMedicalStudies = async (id, files, fileId) => {
  if (fileId && fileId !== undefined) {
    await patchFile({ entity: "candidatoEMedico", entityId: id, fileId, files });
  } else {
    await uploadFiles({ entity: "candidatoEMedico", entityId: id, files });
  }
};

const promiseOptions = (inputValue) =>
  new Promise((resolve) => {
    setTimeout(async () => {
      const params = {
        vendor: inputValue,
      };

      try {
        const response = await getProveedoresMedicalStudies(params);
        const proveedores = response.result;
        const { proveedoresNP } = proveedores || {};

        const options =
          proveedoresNP && proveedoresNP.length > 0
            ? proveedoresNP.map((proveedor) => ({
                label: proveedor.vendor,
                value: proveedor.id,
              }))
            : [];

        resolve(options);
      } catch (error) {
        resolve([]);
      }
    }, 500);
  });
const MedicalStudies = ({ info, notaDePedidoId }) => {
  const { id } = info.candidato;
  const fechaActual = moment().format("YYYY-MM-DD");
  const [fechaExamenValue, setFechaExamenValue] = useState(fechaActual);
  const [examTypeValue, setExamTypeValue] = useState(null);
  const [tipoOtro, setTipoOtro] = useState(false);
  const [tipoOtroValue, setTipoOtroValue] = useState(null);
  const [proveedorValue, setProveedoredorValue] = useState(null);
  const tipo = tipoOtro ? tipoOtroValue : (examTypeValue && examTypeValue.value) || null;
  const [estudios, isLoadingEstudios, , , fetchEstudios] = useFetcher(getMedicalStudies, [id, notaDePedidoId]);
  const [estudioId, setEstudioId] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [isLoadingFiles, setIsLoadingFiles] = useState("");
  const [fileId, setFileId] = useState(null);
  const [files, setFiles] = useState(null);
  const [fileName, setFileName] = useState("Seleccione un archivo");
  const [showForm, setShowForm] = useState(false);
  const [errorTipoOtro, setErrorTipoOtro] = useState(false);
  const [savingStudies, setSavingStudies] = useState(false);
  const [proveedoresDefault, isLoadingProveedoresDefault] = useFetcher(getProveedoresMedicalStudies, [{ vendor: "alf" }]);

  const loadOptions = useDebouncedCallback((inputValue, callback) => {
    promiseOptions(inputValue).then(callback);
  }, 500);

  const conditionalCellStyles = [
    {
      when: (row) => row.id === selectedRowId,
      style: {
        backgroundColor: "#f2eeee",
      },
    },
  ];

  useEffect(() => {
    if (examTypeValue && examTypeValue.value === "Otro") {
      setTipoOtro(true);
    } else {
      setTipoOtro(false);
    }
  }, [examTypeValue]);

  useEffect(() => {
    if (files && files.length > 0) {
      setFileName(files[0].originalname);
      setFileId(files[0].id);
    }
  }, [info]);

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    setFileName(selectedFiles[0].name);
    setFiles(selectedFiles);
  };

  const examTypes = ["Preocupacional", "Psicotecnico", "Otro"];

  const examTypeOptions = examTypes
    ? examTypes
        .map((e) => {
          return { label: e, value: e };
        })
        .sort((a, b) => (a > b ? 1 : -1))
    : [];

  const proveedoresDefaultOptions =
    proveedoresDefault && proveedoresDefault.proveedoresNP ? proveedoresDefault.proveedoresNP.map((proveedor) => ({ label: proveedor.vendor, value: proveedor.id })) : [];

  function getFunctionToFilter(filter, selected) {
    if (filter === "examen") {
      setExamTypeValue(selected);
    }
    if (filter === "proveedor") {
      setProveedoredorValue(selected);
    }
  }
  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const handleDatesChange = (values) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    setFechaExamenValue(fechaFormateada);
  };

  const handleDownloadFile = async (row) => {
    setIsLoadingFiles(row.id);
    await handleClickFile(row.Files[0]);
    setIsLoadingFiles("");
  };

  const handleRowClick = (row) => {
    if (row.id === selectedRowId) {
      setShowForm(false);
      setSelectedRowId(null);
      setEstudioId(null);
      setFechaExamenValue(fechaActual);
      setProveedoredorValue(null);
      setTipoOtro(false);
      setTipoOtroValue(null);
      setExamTypeValue(null);
      setFileId(null);
      setFileName("Seleccione un archivo");
      setFiles(null);
    } else {
      setShowForm(true);
      if (row.Files && row.Files.length > 0) {
        setFiles(row.Files[0]);
        setFileName(row.Files[0].originalname);
        setFileId(row.Files[0].id);
      } else {
        setFileId(null);
        setFileName("Seleccione un archivo");
        setFiles(null);
      }
      setSelectedRowId(row.id);
      setEstudioId(row.id);
      setFechaExamenValue(row.fechaExamen ? moment(row.fechaExamen).format("YYYY-MM-DD") : fechaActual);
      setProveedoredorValue(row.proveedor ? { label: row.proveedor.vendor, value: row.proveedor.id } : null);
      const examType = examTypeOptions.find((e) => e.value === row.tipo);

      if (examType) {
        setExamTypeValue(examType);
        setTipoOtro(false);
      } else {
        setExamTypeValue({ label: "Otro", value: "Otro" });
        setTipoOtroValue(row.tipo);
        setTipoOtro(true);
      }
    }
  };

  const handleGuardar = async () => {
    setSavingStudies(true);
    const medicalStudieData = {
      notaDePedidoId,
      candidatoNPId: id,
      fechaExamen: fechaExamenValue,
      proveedor: proveedorValue ? proveedorValue.value : null,
      tipo: tipo || null,
    };

    if (!medicalStudieData.fechaExamen || !medicalStudieData.proveedor || !medicalStudieData.tipo) {
      toast.error("Por favor complete todos los campos");
      return;
    }

    if (tipoOtro && !tipoOtroValue) {
      setErrorTipoOtro(true);
      toast.error("Por favor ingrese el tipo de examen");
      return;
    }
    setErrorTipoOtro(false);

    try {
      // el 3er parametro valida si el candidato tiene archivo para hacer un patch
      const response = await createOrUpdateMedicalStudies(medicalStudieData, estudioId);
      const newStudie = response.result;
      if (files && files.length > 0) await uploadOrPatchFileMedicalStudies(newStudie.id, files, fileId);
      toast.success(response.message);
      fetchEstudios();
      setShowForm(false);
    } catch (error) {
      handleErrors(error, toast.error);
    }

    setSavingStudies(false);
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
        <Card className="mb-3" style={{ position: "relative", zIndex: "0" }}>
          <BlurSpinner loading={isLoadingEstudios}>
            <CardBody className="pb-3">
              <DataTable
                title={
                  <CardHeader className="pt-1 pb-1 px-0 d-flex align-items-center justify-content-end">
                    <UncontrolledTooltip placement="top" target="addStudy">
                      Agregar estudio médico
                    </UncontrolledTooltip>
                    <Button
                      type="button"
                      color="link"
                      id="addStudy"
                      onClick={() => {
                        setShowForm(true);
                        setSelectedRowId(null);
                        setEstudioId(null);
                        setFechaExamenValue(fechaActual);
                        setProveedoredorValue(null);
                        setTipoOtro(false);
                        setTipoOtroValue(null);
                        setExamTypeValue(null);
                        setFileId(null);
                        setFileName("Seleccione un archivo");
                        setFiles(null);
                      }}
                    >
                      <Plus size="28" color="#f0292a" />
                    </Button>
                  </CardHeader>
                }
                noDataComponent={
                  <div className="p-3">
                    <b>No se encontraron estudios</b>
                  </div>
                }
                onRowClicked={(row) => handleRowClick(row)}
                data={estudios}
                columns={[
                  {
                    name: "Fecha de Examen",
                    selector: (row) => (row.fechaExamen ? moment(row.fechaExamen).format("DD/MM/YY") : "-"),
                    center: true,
                    style: {
                      cursor: "pointer",
                    },
                    conditionalCellStyles,
                  },
                  {
                    name: "Tipo de Estudio",
                    selector: (row) => row.tipo,
                    center: true,
                    style: {
                      cursor: "pointer",
                    },
                    conditionalCellStyles,
                  },
                  {
                    name: "Nombre del Proveedor",
                    selector: (row) => (row.proveedor ? <>{row.proveedor && row.proveedor.vendor}</> : "-"),
                    center: true,
                    style: {
                      cursor: "pointer",
                    },
                    conditionalCellStyles,
                  },
                  {
                    name: "Archivo",
                    selector: (row) =>
                      row.Files.length > 0 ? (
                        <>
                          <UncontrolledTooltip target={`downloadFile${row.id}`}>Descargar archivo</UncontrolledTooltip>
                          <DownloadFileButton
                            id={`downloadFile${row.id}`}
                            aria-label="download file"
                            type="button"
                            style={{ border: "none", background: "none", cursor: "pointer" }}
                            onClick={() => handleDownloadFile(row)}
                          >
                            <BlurSpinner isLoading={isLoadingFiles === row.id}>
                              <FontAwesomeIcon color="#293134" size="lg" icon={getFileIconName(row.Files[0].mimetype)} />
                            </BlurSpinner>
                          </DownloadFileButton>
                        </>
                      ) : (
                        "-"
                      ),
                    // width: "80px",
                    center: true,
                    compact: true,
                    style: {
                      textAlign: "center",
                      cursor: "pointer",
                    },
                    conditionalCellStyles,
                  },
                ]}
              />
            </CardBody>
          </BlurSpinner>
        </Card>

        {showForm && (
          <>
            <div>
              <GridGroup className="mb-1">
                <div>
                  <StylesDatePicker className="mb-1">
                    <CustomLabel htmlFor="fechaAbierta" className=" pt-0 w-100">
                      Fecha de examen
                      <DatePicker
                        className="date-input digits w-100"
                        dateFormat="AAAA-MM-dd"
                        onChange={handleDatesChange}
                        // disabled={formik.isSubmitting}
                        value={formatearFecha(fechaExamenValue)}
                        selected={fechaExamenValue ? new Date(fechaExamenValue).setDate(new Date(fechaExamenValue).getDate() + 1) : null}
                        // minDate={new Date(calcularFechaHabil(fechaActual, -1))}
                      />
                    </CustomLabel>
                  </StylesDatePicker>
                </div>

                <div>
                  <CustomLabel htmlFor="proveedor" className=" pt-0 w-100">
                    Proveedor
                    <AsyncLabSelect
                      id="proveedor"
                      name="proveedor"
                      className="w-100"
                      onChange={handleReactSelectChange}
                      value={proveedorValue}
                      placeholder="Seleccionar..."
                      isClearable
                      loadOptions={loadOptions}
                      defaultOptions={proveedoresDefaultOptions}
                      isLoading={isLoadingProveedoresDefault}
                    />
                  </CustomLabel>
                </div>

                <div>
                  <CustomLabel htmlFor="examen" className=" pt-0 w-100">
                    Tipo de examen
                    <LabSelect
                      id="examen"
                      name="examen"
                      className="w-100"
                      onChange={handleReactSelectChange}
                      value={examTypeValue}
                      placeholder="Seleccionar..."
                      isClearable
                      //   isLoading={isLoadingCategoies}
                      //   isDisabled={isLoadingCategoies}
                      options={examTypeOptions}
                    />
                  </CustomLabel>
                </div>
                {tipoOtro && (
                  <div>
                    <CustomLabel htmlFor="examTypeOtro" className=" pt-0 w-100">
                      Ingrese tipo de examen
                      <InputText
                        className="w-100 "
                        // type="number"
                        name="examTypeOtro"
                        // disabled={formik.isSubmitting}
                        onChange={(e) => {
                          setTipoOtroValue(e.target.value);
                          setErrorTipoOtro(false);
                        }}
                        // onBlur={formik.handleBlur}
                        value={tipoOtroValue}
                        placeholder={errorTipoOtro ? "Ingrese tipo de examen" : null}
                        style={errorTipoOtro ? { borderBottom: "1px solid red" } : null}
                      />
                    </CustomLabel>
                  </div>
                )}
              </GridGroup>

              <div className="mb-3 mt-2">
                <CustomLabel htmlFor="apellido" className="pt-0 w-100">
                  Cargar estudio médico
                  <div className="d-flex align-items-center">
                    <div className="custom-file">
                      <input
                        className="custom-file-input"
                        type="file"
                        id="upfile"
                        onChange={handleFileChange}
                        accept=".pdf, .xls, .xlsx, .doc, .docx, .jpg, .jpeg, .png"
                        style={{ cursor: "pointer", border: "none" }}
                        // disabled={formik.isSubmitting}
                      />
                      <label className="custom-file-label" htmlFor="upfile">
                        {fileName}
                      </label>
                    </div>
                  </div>
                </CustomLabel>
              </div>
            </div>
            <div className="my-2 d-flex justify-content-end" style={{ paddingTop: "10px", borderTop: "1px solid #CCCCCC" }}>
              <Button color="btn-secondary mr-2" onClick={() => setShowForm(false)}>
                Cancelar
              </Button>
              <SpinnerButtonPrimary
                isLoading={savingStudies}
                //   disabled={formik.isSubmitting}
                type="button"
                fontSize="12px"
                onClick={() => handleGuardar()}
              >
                Guardar estudio
              </SpinnerButtonPrimary>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default MedicalStudies;
